const $inject = [];
const lbaRange = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaRangeCtrl',
    controllerAs: 'vm',
    template: require('./lbaRange.html')
  }
};

lbaRange.$inject = $inject;

export default lbaRange;



// WEBPACK FOOTER //
// ./src/components/lbaRange/lbaRangeDir.js